const TEXTS = {
  'en': {
    revisit: [
      {
        'type': 'text',
        'message': 'Hey! It seems like you\'ve already been around this site.',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': 'Would you like to continue the conversation where you left it or start again?',
        'buttons': [ 'START AGAIN', 'CONTINUE' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      }
    ],
  },
  'es': {
    revisit: [
      {
        'type': 'text',
        'message': '¡Hola! Parece que no es la primera vez que visitas esta página.',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': '¿Quieres continuar con la conversación donde la dejaste, o empezar de nuevo?',
        'buttons': [ 'EMPEZAR', 'CONTINUAR' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      }
    ]
  },
  'fr': {
    revisit: [
      {
        'type': 'text',
        'message': 'Salut! Il semble que ce n’est pas la première fois que vous visitez cette page.',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': 'Voulez-vous continuer la conversation là où vous l’avez laissée ou recommencer?',
        'buttons': [ 'COMMENCER', 'CONTINUER' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      },
    ],
  },
  'it': {
    revisit: [
      {
        'type': 'text',
        'message': 'Ciao! Sembra che non sia la prima volta che visiti questa pagina.',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': 'Vuoi continuare con la conversazione da dove l’hai lasciata o preferisci cominciare dall’inizio?',
        'buttons': [ 'RICOMINCIARE', 'CONTINUARE' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      }
    ]
  },
  'de': {
    revisit: [
        {
        'type': 'text',
        'message': 'Hallo! Es scheint, dass es nicht das erste Mal ist, dass Sie diese Seite besuchen.',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': 'Wollen Sie mit der Unterhaltung fortfahren, wo Sie aufgehört haben, oder von vorne beginnen?',
        'buttons': [ 'START', 'WEITER' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      },
    ],
  },
  'pt': {
    revisit: [
      {
        'type': 'text',
        'message': 'Olá! Parece que não é a primeira vez que você visita esta página.',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': 'Você quer continuar com a conversa onde você parou ou começar de novo?',
        'buttons': [ 'INICIAR', 'CONTINUAR' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      },
    ],
  },
  'nl': {
    revisit: [
      {
        'type': 'text',
        'message': 'Hallo! Het lijkt erop dat dit niet de eerste keer is dat u deze pagina bezoekt.',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': 'Wil je doorgaan met het gesprek waar je bent gebleven, of opnieuw beginnen?',
        'buttons': [ 'START', 'DOORGAAN' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      },
    ],
  },
  'zh': {
    revisit: [
      {
        'type': 'text',
        'message': '你好！ 看来，这不是您第一次访问此页面。',
        'samurai': '-1',
        'extra': { hide_textbox: true },
      },
      {
        'type': 'dialog',
        'title': '你想继续谈话，还是从头开始？',
        'buttons': [ '开始', '继续' ],
        'payloads': [ '#init', '#_continue' ],
        'samurai': '-1',
      }
    ],
  },
};

class MultiLangSupport {
  
  constructor() {
    this.lang = this.getLang();
  }

  /**
   * Get language from navigator
   */
  getLang() {
    const _lang = navigator.language || navigator.userLanguage;
    return _lang.substring(0, 2);
  }

  /**
   * Returns the group of messages literals
   * @param {Object} type - group of messages: revisit, ...
   */
  getObject(type) {
    if (TEXTS[this.lang]) {
      return TEXTS[this.lang][type] ? TEXTS[this.lang][type] : TEXTS['en'][type];
    } else
      return TEXTS['en'][type];
  }

}

export default MultiLangSupport;


// WEBPACK FOOTER //
// ../UmiCore/src/MultiLangSupport.js